import { trackPhotosHintScrollToEnd, trackDescriptionHintScrollToEnd } from './tracking';

export const initializeScrollListeners = adAnalyticsCategory => {
  const photosHintElement = document.getElementById('photos-hint');
  const descriptionHintElement = document.getElementById('description-hint');

  const photosEventListener = event => {
    const element = event.target;

    if (element.scrollHeight - element.scrollTop === element.clientHeight) {
      trackPhotosHintScrollToEnd(adAnalyticsCategory);

      photosHintElement.removeEventListener('scroll', photosEventListener);
    }
  };

  if (photosHintElement) {
    photosHintElement.addEventListener('scroll', photosEventListener);
  }

  const descriptionEventListener = event => {
    const element = event.target;

    if (element.scrollHeight - element.scrollTop === element.clientHeight) {
      trackDescriptionHintScrollToEnd(adAnalyticsCategory);

      descriptionHintElement.removeEventListener('scroll', descriptionEventListener);
    }
  };

  if (descriptionHintElement) {
    descriptionHintElement.addEventListener('scroll', descriptionEventListener);
  }

  return () => {
    if (photosHintElement) {
      photosHintElement.removeEventListener('scroll', photosEventListener);
    }

    if (descriptionHintElement) {
      descriptionHintElement.removeEventListener('scroll', descriptionEventListener);
    }
  };
};
